module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00291.ed83279f.jpg";